// import { initPreheader } from './preheader';
// import { unstickPreheader } from './unstick-preheader';
import initStickyHeader from './sticky-header';
import { initMobileNav, closeMobileNav } from './mobile-nav';
import { initDesktopNav } from './desktop-nav';
import { closeSliderCart } from '../slider-cart';
import { closeMobileFilterNav } from '../../components/mobile-filter-nav';
import { initCountdownBanner } from './countdown';
import initNavADA from './ada';

export default () => {
  $(document).on('click touchend', '[data-close-drawer]', () => {
    if ($('.mobile-nav-opened').length) {
      closeMobileNav();
      return;
    }

    if ($('.slider-cart-opened').length) {
      closeSliderCart();
      return;
    }

    const from_search = document.body.classList.contains('has-overlay-search');
    const prefix = from_search ? 'overlay-search-' : '';

    if ($(`.mobile-${prefix}filter-nav-opened`).length) {
      closeMobileFilterNav();
      return;
    }
  });

  $(window).on('scroll', _.debounce(() => {
    $(window).scrollTop() > 0 ? $('body').addClass('scrolled') : $('body').removeClass('scrolled');
  }, 10));

  // initPreheader();
  // unstickPreheader();
  initStickyHeader();
  initDesktopNav();
  initMobileNav();
  initCountdownBanner();
  initNavADA();
};
